import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';
import AgeGate from './components/AgeGate';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import ChiSono from './pages/ChiSono';
import PercheUnAccompagnatore from './pages/PercheUnAccompagnatore';
import ProveDiFedelta from './pages/ProveDiFedelta';
import ServiziOfferti from './pages/ServiziOfferti';
import ServiziDiLusso from './pages/ServiziDiLusso';
import Gallery from './pages/Gallery';
import Contatti from './pages/Contatti';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookiePolicy from './pages/CookiePolicy';
import Termini from './pages/Termini';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chi-sono" element={<ChiSono />} />
          <Route path="/perche-un-accompagnatore" element={<PercheUnAccompagnatore />} />
          <Route path="/prove-di-fedelta" element={<ProveDiFedelta />} />
          <Route path="/servizi-offerti" element={<ServiziOfferti />} />
          <Route path="/servizi-di-lusso" element={<ServiziDiLusso />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/termini-condizioni" element={<Termini />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <CookieBanner />
        <AgeGate />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
